<template>
  <Head title="Lihat Dokumen" />
  <Container>
    <template #header>
      <Header :menu="$page.props.main_menu" v-if="$page.props.auth.user" />
    </template>
    <template #default>
      <div class="container px-4 mx-auto">
        <Breadcrumbs :breadcrumbs="[
          { name: 'Dashboard', href: route('dashboard') },
          { name: `Kinerja Program Studi`, href: route('kinerja.index') },
          {
            name: `${doc.kinerjaprogram?.instrumen ?? ''}`,
            href: route('kinerja.adddocument', doc.kinerjaprogram?.slugid),
          },
          { name: `${doc.nama_dok}`, href: route('kinerja.show', doc.iddok) },
        ]" />

        <!-- Title -->
        <div class="flex flex-col items-start gap-2 mt-2 mb-5 md:flex-row md:items-end md:justify-between">
          <h1 class="text-2xl font-bold text-gray-900 break-words sm:text-3xl">
            {{ doc.nama_dok }}
          </h1>
          <p class="text-sm text-gray-500 break-words">
            Dokumen Kinerja / {{ doc.kinerjaprogram?.akreditasi?.akreditasi || "N/A" }}
          </p>
        </div>

        <div class="grid grid-cols-1 gap-6 lg:grid-cols-3">
          <!-- Info + actions -->
          <div class="lg:col-span-1">
            <div class="overflow-hidden bg-white border border-gray-200 shadow-sm rounded-xl">
              <div class="px-4 py-3 border-b border-gray-100 bg-gray-50">
                <h2 class="text-sm font-semibold text-gray-800">Detail Dokumen</h2>
              </div>
              <dl class="text-sm divide-y divide-gray-100">
                <div class="grid grid-cols-3 gap-2 px-4 py-3">
                  <dt class="font-medium text-gray-500">Nama</dt>
                  <dd class="col-span-2 text-gray-900 break-words">{{ doc.nama_dok }}</dd>
                </div>
                <div class="grid grid-cols-3 gap-2 px-4 py-3">
                  <dt class="font-medium text-gray-500">Jenis</dt>
                  <dd class="col-span-2 text-gray-900 break-words">{{ doc.jenisdokumen?.nama }}</dd>
                </div>
                <div class="grid grid-cols-3 gap-2 px-4 py-3">
                  <dt class="font-medium text-gray-500">Deskripsi</dt>
                  <dd class="col-span-2 text-gray-900 break-words">{{ doc.deskripsi || "-" }}</dd>
                </div>
                <div class="grid grid-cols-3 gap-2 px-4 py-3">
                  <dt class="font-medium text-gray-500">Kategori Data</dt>
                  <dd class="col-span-2 text-gray-900 break-words">{{ doc.publish }}</dd>
                </div>
              </dl>

              <!-- Action bar -->
              <div v-if="$page.props.auth.user"
                class="flex flex-wrap gap-2 px-4 py-3 border-t border-gray-100 bg-gray-50/60">
                <button @click="editDokumen(doc.iddok)"
                  class="inline-flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium text-gray-800 bg-white border border-gray-300 rounded-lg shadow-sm hover:bg-gray-50 transition-colors">
                  <i class="fa-solid fa-pen"></i> Edit Dokumen
                </button>
                <button @click="editFile(doc.iddok)"
                  class="inline-flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium text-gray-800 bg-white border border-gray-300 rounded-lg shadow-sm hover:bg-gray-50 transition-colors">
                  <i class="fa-solid fa-file-arrow-up"></i> Edit File
                </button>
                <button @click="hapusDokumen(doc.id)"
                  class="inline-flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium text-white bg-red-600 rounded-lg shadow-sm hover:bg-red-700 transition-colors">
                  <i class="fa-solid fa-trash"></i> Hapus
                </button>
              </div>
            </div>
          </div>

          <!-- File preview -->
          <div class="lg:col-span-2">
            <div class="overflow-hidden bg-white border border-gray-200 shadow-sm rounded-xl">
              <div class="px-4 py-3 border-b border-gray-100 bg-gray-50">
                <h2 class="text-sm font-semibold text-gray-800">Lampiran File</h2>
              </div>
              <div class="p-4">
                <div v-if="filePath && filePath.length" class="space-y-4">
                  <div v-for="(file, index) in filePath" :key="index">
                    <div v-if="isImage(file)" class="overflow-hidden border border-gray-200 rounded-lg bg-gray-50">
                      <img :src="file" alt="Preview" class="object-contain w-full max-h-[50vh] sm:max-h-[70vh] mx-auto" />
                    </div>
                    <embed v-else-if="isPdf(file)" :src="file" type="application/pdf"
                      class="w-full h-[50vh] sm:h-[65vh] lg:h-[80vh] border border-gray-200 rounded-lg" />
                    <div v-else
                      class="flex flex-wrap items-center justify-between gap-3 p-3 border border-gray-200 rounded-lg bg-gray-50">
                      <span class="text-sm text-gray-600 break-words">
                        <i class="mr-1 fa-solid fa-file"></i> Preview tidak tersedia
                      </span>
                      <a :href="file" target="_blank"
                        class="text-xs font-semibold text-indigo-600 hover:underline shrink-0">Unduh</a>
                    </div>
                  </div>
                </div>
                <p v-else class="py-12 text-sm text-center text-gray-400">
                  Belum ada file lampiran.
                </p>
              </div>
            </div>

            <ModalEditDokumen v-model:isOpen="isModalOpen" :title="'Edit Dokumen'" :repository="viewdokumen"
              :prodis="selectedProdi" :jenis="selectedJenis" />
            <ModalFile v-model:isOpen="isModalFile" :title="'Edit File'" :repository="viewdokumen" />
          </div>
        </div>
      </div>
    </template>
  </Container>
</template>

<script setup>
import { defineProps, watch, ref, computed } from "vue";
import { Head, router } from "@inertiajs/vue3";
import Swal from "sweetalert2";
import Container from "@/Layouts/Container.vue";
import Header from "@/Components/Header.vue";
import ModalEditDokumen from "@/Components/Kinerja/ModalEditDokumen.vue";
import ModalFile from "@/Components/Kinerja/ModalFile.vue";
import Breadcrumbs from "@/Components/Breadcrumbs.vue";

const props = defineProps({
  filerepo: {
    type: Array,
    required: true,
  },
  instrumens: {
    type: Object,
    required: true,
  },
});

const doc = computed(() => props.filerepo?.data?.[0] || {});

const isModalOpen = ref(false);
const isModalFile = ref(false);
const viewdokumen = ref(null);
const selectedJenis = ref(null);
const selectedProdi = ref(null);

const filePath = ref(props.filerepo.data[0].file_path);

watch(
  () => props.filerepo,
  (newFilerepo) => {
    filePath.value = newFilerepo.data[0].file_path;
  }
);

const editDokumen = async (iddok) => {
  try {
    const response = await fetch(`/viewdockinerja/${iddok}`);
    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
    const data = await response.json();
    viewdokumen.value = data.dokumen;
    selectedJenis.value = data.jenis;
    selectedProdi.value = data.prodis;
    isModalOpen.value = true;
  } catch (error) {
    console.error("Error fetching data:", error.message);
  }
};

const editFile = async (iddok) => {
  try {
    const response = await fetch(`/viewdockinerja/${iddok}`);
    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
    const data = await response.json();
    viewdokumen.value = data.dokumen;
    selectedJenis.value = data.jenis;
    isModalFile.value = true;
  } catch (error) {
    console.error("Error fetching data:", error.message);
  }
};

const hapusDokumen = async (id) => {
  const result = await Swal.fire({
    title: "Hapus dokumen?",
    text: "Dokumen beserta file lampiran akan dihapus permanen.",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#dc2626",
    cancelButtonColor: "#6b7280",
    confirmButtonText: "Ya, hapus",
    cancelButtonText: "Batal",
  });
  if (!result.isConfirmed) return;

  router.delete(route("kinerja.destroy", id), {
    preserveScroll: true,
    onError: () =>
      Swal.fire({ title: "Gagal", text: "Tidak dapat menghapus dokumen.", icon: "error" }),
  });
};

function isImage(filePath) {
  return /\.(jpg|jpeg|png|gif|bmp|webp)$/i.test(filePath);
}

function isPdf(filePath) {
  return /\.pdf$/i.test(filePath);
}
</script>
